module.exports = __webpack_public_path__ + "img/pose-f-39.4b224c1e.png";